<div class="tktw" *ngIf="visivel">

    <!-- ─────────────── painel ─────────────── -->
    <div class="tktw__painel" *ngIf="aberto">

        <div class="tktw__cabecalho">

            <button nz-button nzType="text" nzSize="small" *ngIf="selecionado != null"
                (click)="fecharConversa()" [nz-tooltip]="'tkt.widget.voltar'|translateTA">
                <nz-icon nzType="arrow-left"></nz-icon>
            </button>

            <span class="tktw__titulo" *ngIf="selecionado == null">
                {{'tkt.widget.titulo'|translateTA}}
            </span>

            <span class="tktw__titulo" *ngIf="selecionado != null">
                <span class="tktw__numero">{{selecionado.numero}}</span>
                <nz-tag [nzColor]="statusColor(selecionado)">{{statusLabel(selecionado.status)}}</nz-tag>
            </span>

            <button nz-button nzType="text" nzSize="small" (click)="fechar()"
                [nz-tooltip]="'tkt.conversa.fechar'|translateTA">
                <nz-icon nzType="close"></nz-icon>
            </button>
        </div>

        <!-- ─── lista dos meus chamados ─── -->
        <div class="tktw__lista" *ngIf="selecionado == null">

            <div class="tktw__item" *ngFor="let chamado of meusChamados" (click)="abrirConversa(chamado)">

                <div class="tktw__item-topo">
                    <span class="tktw__numero">{{chamado.numero}}</span>
                    <nz-tag [nzColor]="statusColor(chamado)">{{statusLabel(chamado.status)}}</nz-tag>
                    <!-- Ponto de novidade: o contador do balão vem daqui. -->
                    <span class="tktw__ponto" *ngIf="temNovidade(chamado)"></span>
                    <span class="tktw__hora">{{chamado.ultimaMensagem?.em | date:'dd/MM HH:mm'}}</span>
                </div>

                <div class="tktw__assunto">{{chamado.assunto}}</div>
                <div class="tktw__previa">{{resumo(chamado)}}</div>
            </div>
        </div>

        <!-- ─── conversa ─── -->
        <nz-spin [nzSpinning]="carregandoConversa" class="tktw__conversa" #corpoDaConversa *ngIf="selecionado != null">

            <div class="conversa__timeline">

                <ng-container *ngFor="let entrada of timeline">

                    <div class="evento" *ngIf="entrada.kind === 'EVENTO'">
                        <nz-icon [nzType]="eventoIcone(entrada)"></nz-icon>
                        <span class="evento__texto">{{eventoTexto(entrada)}}</span>
                        <span class="evento__hora">{{entrada.em | date:'dd/MM HH:mm'}}</span>
                    </div>

                    <div class="msg" *ngIf="entrada.kind === 'MENSAGEM'"
                        [class.msg--cliente]="mensagemDoCliente(entrada)">

                        <div class="msg__balao">
                            <div class="msg__cabecalho">
                                <nz-tag [nzColor]="autorCor(entrada)">{{autorNome(entrada)}}</nz-tag>
                                <span class="msg__hora">{{entrada.em | date:'dd/MM HH:mm'}}</span>
                            </div>
                            <div class="msg__texto">{{entrada.mensagem.texto}}</div>

                            <div class="msg__anexos" *ngIf="anexosDe(entrada).length > 0">
                                <ng-container *ngFor="let anexo of anexosDe(entrada)">
                                    <a class="anexo" *ngIf="linkDoAnexo(anexo) != null"
                                        [href]="linkDoAnexo(anexo)" target="_blank" rel="noopener">
                                        <nz-icon [nzType]="iconeDoAnexo(anexo)"></nz-icon>
                                        <span class="anexo__nome">{{anexo.nome}}</span>
                                    </a>
                                    <!-- Sem URL guardada, o `ref` e a CHAVE do objeto: o link
                                         e assinado na hora de abrir, dura minutos e so sai
                                         para quem pode ver este chamado. -->
                                    <button class="anexo anexo--acao" type="button"
                                        *ngIf="linkDoAnexo(anexo) == null && anexo.ref"
                                        (click)="abrirAnexo(anexo, selecionado._id)">
                                        <nz-icon [nzType]="iconeDoAnexo(anexo)"></nz-icon>
                                        <span class="anexo__nome">{{anexo.nome}}</span>
                                    </button>

                                    <!-- Sem referencia nenhuma: o anexo e so o registro de que
                                         existe. Link quebrado seria pior. -->
                                    <span class="anexo anexo--sem-link"
                                        *ngIf="linkDoAnexo(anexo) == null && !anexo.ref"
                                        nz-tooltip [nzTooltipTitle]="'tkt.conversa.anexoSemLink'|translateTA">
                                        <nz-icon [nzType]="iconeDoAnexo(anexo)"></nz-icon>
                                        <span class="anexo__nome">{{anexo.nome}}</span>
                                    </span>

                                </ng-container>
                            </div>
                        </div>
                    </div>

                </ng-container>

                <nz-empty *ngIf="!carregandoConversa && timeline.length === 0"
                    [nzNotFoundContent]="'tkt.conversa.vazia'|translateTA"></nz-empty>

            </div>
        </nz-spin>

        <!-- ─── caixa de resposta ─── -->
        <div class="composer__subindo" *ngIf="enviandoAnexo">
            <nz-spin nzSimple nzSize="small"></nz-spin>
            <span>{{'tkt.anexo.subindo'|translateTA}}</span>
        </div>

        <div class="tktw__anexos" *ngIf="selecionado != null && anexos.length > 0">
            <nz-tag *ngFor="let anexo of anexos; let i = index" nzMode="closeable"
                (nzOnClose)="removerAnexo(i)">
                <nz-icon nzType="paper-clip"></nz-icon> {{anexo.nome}}
            </nz-tag>
        </div>

        <div class="tktw__composer" *ngIf="selecionado != null && podeResponder">
            <textarea nz-input rows="2" [(ngModel)]="textoResposta"
                [placeholder]="'tkt.meus.responderPlaceholder'|translateTA"></textarea>

            <!-- Anexo EM CIMA do enviar: a coluna ocupa a largura de um botao
                 so, e o balao nao tem largura para gastar. -->
            <div class="tktw__acoes">
                <nz-upload [nzBeforeUpload]="aoEscolherAnexo" [nzShowUploadList]="false"
                    [nzMultiple]="true" [nzDisabled]="enviandoAnexo">
                    <button nz-button nzSize="small" type="button" [nzLoading]="enviandoAnexo"
                        [nz-tooltip]="'tkt.anexo.escolher'|translateTA">
                        <nz-icon nzType="paper-clip"></nz-icon>
                    </button>
                </nz-upload>

                <button nz-button nzType="primary" nzSize="small" (click)="enviar()"
                    [nzLoading]="enviando" [disabled]="!podeEnviar">
                    <nz-icon nzType="send"></nz-icon>
                </button>
            </div>
        </div>

        <div class="tktw__rodape">
            <button nz-button nzType="link" nzSize="small" (click)="verTodos()">
                {{'tkt.widget.verTodos'|translateTA}}
            </button>
            <button nz-button nzType="link" nzSize="small" (click)="abrirNovo()">
                {{'tkt.meus.abrirNovo'|translateTA}}
            </button>
        </div>
    </div>

    <!-- ─────────────── botão ─────────────── -->
    <button class="tktw__botao" (click)="alternar()"
        [nz-tooltip]="'tkt.widget.titulo'|translateTA" nzTooltipPlacement="left">
        <nz-icon [nzType]="aberto ? 'close' : 'message'"></nz-icon>
        <span class="tktw__badge" *ngIf="!aberto && naoLidos > 0">{{naoLidos}}</span>
    </button>
</div>
